{
    "name": "genesistrailers.client",
    "version": "26.1103.0",
    "scripts": {
        "ng": "ng",
        "prestart": "pnpm install",
        "start": "ng serve --port 5180 -o",
        "build": "ng build --base-href /vnext/ --configuration production --source-map --aot false",
        "build-prod": "ng build --base-href /app/ --configuration production --source-map --aot false --build-optimizer false",
        "test": "ng test",
        "lint": "ng lint",
        "e2e": "ng e2e"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "21.0.5",
        "@angular/common": "21.0.5",
        "@angular/compiler": "21.0.5",
        "@angular/core": "21.0.5",
        "@angular/forms": "21.0.5",
        "@angular/platform-browser": "21.0.5",
        "@angular/platform-browser-dynamic": "21.0.5",
        "@angular/platform-server": "21.0.5",
        "@angular/router": "21.0.5",
        "@capacitor/android": "^7.0.0",
        "@capacitor/camera": "^7.0.0",
        "@capacitor/core": "^7.0.0",
        "@capacitor/ios": "^7.0.0",
        "@ionic/angular": "^8.4.3",
        "@ionic/core": "^8.4.3",
        "animate.css": "3.7.0",
        "bootstrap": "5.3.3",
        "breeze-client": "^2.1.5",
        "breeze-client-labs": "^1.5.12",
        "breeze-entity-generator": "^1.4.1",
        "chart.js": "^4.4.0",
        "core-js": "^2.6.1",
        "devextreme": "25.2.5",
        "devextreme-angular": "25.2.5",
        "exceljs": "^4.4.0",
        "file-saver": "^2.0.5",
        "font-awesome": "^4.7.0",
        "jquery": "^3.7.1",
        "jquery-slimscroll": "^1.3.8",
        "lodash": "^4.17.21",
        "metismenu": "^3.0.7",
        "moment": "^2.29.4",
        "ngx-bootstrap": "^21.0.1",
        "rxjs": "^7.8.0",
        "stream": "0.0.2",
        "tslib": "^2.0.0",
        "zone.js": "~0.15.0"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^21.0.5",
        "@angular-devkit/core": "21.0.5",
        "@angular-devkit/schematics": "21.0.5",
        "@angular/cli": "^21.0.5",
        "@angular/compiler-cli": "21.0.5",
        "@capacitor/cli": "^6.0.0",
        "@ionic/angular-toolkit": "latest",
        "@types/file-saver": "^2.0.5",
        "@types/lodash": "^4.14.119",
        "@types/node": "^12.11.1",
        "codelyzer": "^6.0.0",
        "protractor": "~7.0.0",
        "ts-node": "~7.0.1",
        "tslint": "~6.1.0",
        "typescript": "5.9.2"
    }
}
